import React, {useState, useEffect, useContext} from 'react'
import { UserContext } from '../layouts/UserContext';
import { Link } from 'gatsby'

const Pricing = () => {

const location = useContext(UserContext)

    return (
        <section className="pricing_area sec_pad">
            <div className="container custom_container p0">
                <div className="sec_title text-center">
                    <h2 className="f_p f_size_40 l_height50 f_600">Full Featured Free Version</h2>
                    <p className="f_400 f_size_16 l_height30 mb_20">Try out the full suite of Workhub components with no strings attached <br />or get started right away with our low priced standard version. </p>
                </div>

                <div className="tab-content price_content" id="myTabContent">
                    <div className="tab-pane fade show active">
                        <div className="row">
                            <div className="col-lg-2 col-sm-1">
                            </div>
                            <div className="col-lg-4 col-sm-5 mt-2">
                                <div className="price_item">
                                    <img loading="lazy" src="/home2/price-2.png" alt="Software Vector" />
                                    <h3 className="f_p f_size_20 f_600 t_color2 mt_30" style={{marginBottom: 0, fontSize: '18px', lineHeight: '22px', color: '#212322'}}>Free</h3>
                                    <p>Try the Entire Suite</p>
                                    <Link to="/pricing/" className="erp_btn_learn">See full comparison<i className="arrow_right"></i></Link>
                                    <div className="price f_700 f_size_50 t_color2">$0<br /><sub className="f_size_16 f_400">/ mo per user</sub></div>
                                    <ul className="list-unstyled p_list">
                                    <li><i className="ti-check"></i>Access to try all Features</li>
                                        <li><i className="ti-check"></i>File Upload Limit</li>
                                        <li><i className="ti-check"></i>Limited Support</li>
                                        <li><i className="ti-close"></i>No Data Exports</li>
                                        <li><i className="ti-close"></i>No Hidden Costs</li>
                                    </ul>
                                    <Link to="/signup/" className="price_btn btn_hover">Go Free</Link>
                                    <i className="no-cc">No credit card needed</i>
                                </div>
                            </div>

                            <div className="col-lg-4 col-sm-5 mt-2">
                                <div className="price_item">
                                    <img loading="lazy" src="/home2/price-1.png" alt="Trophy Vector" />
                                    <h3 className="f_p f_size_20 f_600 t_color2 mt_30" style={{marginBottom: 0, fontSize: '18px', lineHeight: '22px', color: '#212322'}}>Standard</h3>
                                    <p>No contracts. No hidden fees. Full support.</p>
                                    <Link to="/pricing/" className="erp_btn_learn">See full comparison<i className="arrow_right"></i></Link>

                                    {location === "US" || location === undefined ? (<><div className="price f_700 f_size_50 t_color2">$3<br /><sub className="f_size_16 f_400"> (USD) / mo per user</sub></div></>) : null}

                                    {location === "CA" ? (<><div className="price f_700 f_size_50 t_color2">$4<br /><sub className="f_size_16 f_400"> (CAD) / mo per user</sub></div></>) : null}

                                    {location !== 'US' && location !== 'CA' && location !== undefined ? (<><div className="price f_700 f_size_50 t_color2">$3<br /><sub className="f_size_16 f_400"> (USD) / mo per user</sub></div></>) : null}
                                    
                                    <ul className="list-unstyled p_list">
                                    <li><i className="ti-check"></i>Custom Branding</li>
                                        <li><i className="ti-check"></i>Location Based Assignments</li>
                                        <li><i className="ti-check"></i>Full Phone / Email Support</li>
                                        <li><i className="ti-check"></i>SMS Notifications</li>
                                        <li><i className="ti-check"></i>Data Imports / Exports</li>
                                        <li><i className="ti-check"></i>1 Month Free Trial</li>
                                    </ul>
                                    <Link to="/signup/" className="price_btn btn_hover">Get Started</Link>
                                    <i className="no-cc">No credit card needed</i>

                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-1">
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Pricing